import React from 'react';

import { Card } from '@buildoutinc/blueprint-react/ui/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import LoadingSpinner from 'components/ui/loading_spinner';

import type { InlineToolCall, ProgressStep, RecommendationsToolCall } from '../types';

interface StepCardProps {
  steps: ProgressStep[];
}

interface RecommendationStepsProps {
  toolCalls: RecommendationsToolCall[];
}

export function StepCard({ steps }: StepCardProps) {
  if (!steps.length) {
    return null;
  }

  return (
    <Card className="mb-2">
      <Card.Body className="d-flex flex-column gap-2 small">
        {steps.map(step => (
          <div className="d-flex align-items-center gap-2" key={step.key}>
            {step.done
              ? <FontAwesomeIcon className="text-success flex-shrink-0" icon={faCheck} />
              : <LoadingSpinner className="flex-shrink-0" inline size="sm" skipTopBuffer />}
            <span className={step.done ? undefined : 'text-muted'}>{step.label}</span>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
}

export function liveSteps(steps?: ProgressStep[], toolCalls: InlineToolCall[] = []) {
  return toolCalls.some(toolCall => 'steps' in toolCall.metadata) ? undefined : steps;
}

export function RecommendationSteps({ toolCalls }: RecommendationStepsProps) {
  return <StepCard steps={toolCalls.reduce<ProgressStep[]>((steps, call) => steps.concat(call.metadata.steps), [])} />;
}
